<template>
  <v-container fluid>
    <v-row v-if="pdfs && pdfs.length > 0">
      <v-col v-for="pdf in parsedPDFs" :key="pdf.url"
        cols="12" sm="6" xl="3" lg="4"
      >
        <AmtstafelCard :label="pdf.txt" :pdf="pdf.url" :main-color="mainColor" :chip="pdf.chip" :dark="dark" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import axios from 'axios'
  import { encode, escape } from 'base64-url'

  import AmtstafelCard from './AmtstafelCard.vue'

  export default {
    name: 'Amtstafel',
    props: ["startUrl", "mainColor", "dark"],
    components: {
      AmtstafelCard
    },
    computed: {
      parsedPDFs(){
        return this.pdfs.flat()
      }
    },
    methods: {
      async pdfsFromPage(url){
        const encodedUrl = escape(encode(url))
        const response = await axios({
          url: `https://graphql.sta.io/proxy/bsBi1mr1F/${encodedUrl}`
        })
        const dom = new DOMParser().parseFromString(response.data, "text/html")
        const pdfs = [...dom.querySelectorAll("div.mainContent a[href$='.pdf' i]")].map(a => {
            const pdfUrl = new URL(a.getAttribute('href'), url).toString()
            const txt = a.textContent
            const chip = null
            return { url: pdfUrl, txt, chip }
        })
        return pdfs
      },
      load(){
        this.getPages()
      },
      async getPages(){
        this.pdfs = await this.pdfsFromPage(this.startUrl)
      }
    },
    mounted(){
      this.load()
      setInterval(() => {
        this.load()
      }, 1000*60*5)
    },
    watch: {
      startUrl(){
        this.load()
      }
    },
    data: () => ({
      dom: null,
      pdfs: null,
    }),
  }
</script>
